export const STATUS_TICKET_ACTIVE = 1
export const STATUS_TICKET_CLOSED = 2
